import script from "./GeneralArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralArea.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralArea.vue?vue&type=style&index=0&id=2a23f287&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a23f287"]])

export default __exports__